// Internal modules
import { appStore } from '@/store';
import { getContent } from '@/lib';
/**
 * @function getCardTypeSelectOptions
 * @param {array} allowedCardTypes
 * @returns {array}
 * @description get allowedCardTypes which is array of strings, and
 * and return the array of objects - object required to render a
 * select html element out of objects in the array
 * eg: [{ key: 0, value: 'AMEX', displayText: 'american express'}]
 */
const getCardTypeSelectOptions = allowedCardTypes => {
  const { multiBrandCardTypes } = appStore.getState().ui;
  return allowedCardTypes
    .filter(cardType =>
      multiBrandCardTypes.length > 0
        ? multiBrandCardTypes.includes(cardType)
        : cardType,
    )
    .map(cardType => ({
      displayText: getContent(`cardTypes.${cardType}`) || cardType,
      value: cardType,
    }));
};

export { getCardTypeSelectOptions };
